import { render } from "./TissConsultationGuideForm.vue?vue&type=template&id=72c01516"
import script from "./TissConsultationGuideForm.vue?vue&type=script&lang=js"
export * from "./TissConsultationGuideForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__